import client from './main-client';

export const fetchInboxEmailsApi = (params) => client().get('/inbox', { params });
export const getInboxEmailApi = ({ id, ...params }) => client().get(`/inbox/${id}`, { params });
export const updateInboxEmailApi = (params) => client().put(`/inbox/${params.id}`, params);
export const addInboxEmailApi = (data) => client().post('/inbox', data);
export const deleteInboxEmailApi = (params) => client().delete(`/inbox/${params.id}`, { params });
